import {
  ADD_CHARACTER_CATEGORY,
  DELETE_CHARACTER_CATEGORY,
  UPDATE_CHARACTER_CATEGORY,
  REORDER_CHARACTER_CATEGORY,
  ADD_NOTE_CATEGORY,
  DELETE_NOTE_CATEGORY,
  UPDATE_NOTE_CATEGORY,
  REORDER_NOTE_CATEGORY,
  ADD_TAG_CATEGORY,
  DELETE_TAG_CATEGORY,
  UPDATE_TAG_CATEGORY,
  REORDER_TAG_CATEGORY,
  ADD_PLACE_CATEGORY,
  DELETE_PLACE_CATEGORY,
  UPDATE_PLACE_CATEGORY,
  REORDER_PLACE_CATEGORY,
  LOAD_CATEGORIES,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../types/plottr').CategoriesPlottrFile} CategoriesPlottrFile
 * @typedef {import('../types/plottr').Category} Category
 */

/**
 * @typedef {ReturnType<typeof addCharacterCategory> | ReturnType<typeof deleteCharacterCategory> | ReturnType<typeof updateCharacterCategory> | ReturnType<typeof reorderCharacterCategory> | ReturnType<typeof addNoteCategory> | ReturnType<typeof deleteNoteCategory> | ReturnType<typeof updateNoteCategory> | ReturnType<typeof reorderNoteCategory> | ReturnType<typeof addTagCategory> | ReturnType<typeof deleteTagCategory> | ReturnType<typeof updateTagCategory> | ReturnType<typeof reorderTagCategory> | ReturnType<typeof addPlaceCategory> | ReturnType<typeof deletePlaceCategory> | ReturnType<typeof updatePlaceCategory> | ReturnType<typeof reorderPlaceCategory> | ReturnType<typeof load>} CategoriesActions
 */

/**
 * @param {String} name
 * @return {{ type: 'ADD_CHARACTER_CATEGORY', name: String }}
 */
export function addCharacterCategory(name) {
  return {
    type: ADD_CHARACTER_CATEGORY,
    name,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'DELETE_CHARACTER_CATEGORY', category: Category }}
 */
export function deleteCharacterCategory(category) {
  return {
    type: DELETE_CHARACTER_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'UPDATE_CHARACTER_CATEGORY', category: Category }}
 */
export function updateCharacterCategory(category) {
  return {
    type: UPDATE_CHARACTER_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @param {number} toIndex
 * @return {{ type: 'REORDER_CHARACTER_CATEGORY', category: Category, toIndex: number }}
 */
export function reorderCharacterCategory(category, toIndex) {
  return {
    type: REORDER_CHARACTER_CATEGORY,
    category,
    toIndex,
  }
}

/**
 * @param {String} name
 * @return {{ type: 'ADD_NOTE_CATEGORY', name: String }}
 */
export function addNoteCategory(name) {
  return {
    type: ADD_NOTE_CATEGORY,
    name,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'DELETE_NOTE_CATEGORY', category: Category }}
 */
export function deleteNoteCategory(category) {
  return {
    type: DELETE_NOTE_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'UPDATE_NOTE_CATEGORY', category: Category }}
 */
export function updateNoteCategory(category) {
  return {
    type: UPDATE_NOTE_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @param {number} toIndex
 * @return {{ type: 'REORDER_NOTE_CATEGORY', category: Category, toIndex: number }}
 */
export function reorderNoteCategory(category, toIndex) {
  return {
    type: REORDER_NOTE_CATEGORY,
    category,
    toIndex,
  }
}

/**
 * @param {String} name
 * @return {{ type: 'ADD_TAG_CATEGORY', name: String }}
 */
export function addTagCategory(name) {
  return {
    type: ADD_TAG_CATEGORY,
    name,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'DELETE_TAG_CATEGORY', category: Category }}
 */
export function deleteTagCategory(category) {
  return {
    type: DELETE_TAG_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'UPDATE_TAG_CATEGORY', category: Category }}
 */
export function updateTagCategory(category) {
  return {
    type: UPDATE_TAG_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @param {number} toIndex
 * @return {{ type: 'REORDER_TAG_CATEGORY', category: Category, toIndex: number }}
 */
export function reorderTagCategory(category, toIndex) {
  return {
    type: REORDER_TAG_CATEGORY,
    category,
    toIndex,
  }
}

/**
 * @param {String} name
 * @return {{ type: 'ADD_PLACE_CATEGORY', name: String }}
 */
export function addPlaceCategory(name) {
  return {
    type: ADD_PLACE_CATEGORY,
    name,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'DELETE_PLACE_CATEGORY', category: Category }}
 */
export function deletePlaceCategory(category) {
  return {
    type: DELETE_PLACE_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @return {{ type: 'UPDATE_PLACE_CATEGORY', category: Category }}
 */
export function updatePlaceCategory(category) {
  return {
    type: UPDATE_PLACE_CATEGORY,
    category,
  }
}

/**
 * @param {Category} category
 * @param {number} toIndex
 * @return {{ type: 'REORDER_PLACE_CATEGORY', category: Category, toIndex: number }}
 */
export function reorderPlaceCategory(category, toIndex) {
  return {
    type: REORDER_PLACE_CATEGORY,
    category,
    toIndex,
  }
}

/**
 * @param {boolean} patching
 * @param {CategoriesPlottrFile} categories
 * @return {{ type: 'LOAD_CATEGORIES', patching: boolean, categories: CategoriesPlottrFile }}
 */
export function load(patching, categories) {
  return { type: LOAD_CATEGORIES, patching, categories }
}
